export default async function getLocationName() {
  const ipResponse = await fetch("https://ipapi.co/json/")
  const ipData = await ipResponse.json()
  const { city, country } = ipData

  return `${city}, ${country}`
}
